
import { Glide, GlideSlide } from 'vue-glide-js';
import WpImage from '~/components/ui/img.vue';
import 'vue-glide-js/dist/vue-glide.css';

export default {
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    WpImage,
  },

  props: {
    images: {
      type: Array,
      default: null,
    },
    loading: {
      type: String,
      default: 'lazy',
    },
  },

  data() {
    return {
      active: 0,
      thumbs: 5,
      thumbsMobile: 3,
      activeThumb: 0,
    };
  },

  methods: {
    link(url) {
      return '/' + url;
    },
    imageClicked(i) {
      this.$emit('clicked', i);
    },
    moveToSlide(index) {
      this.active = index;
      this.updateThumbsPosition();
    },
    canNavigate(direction) {
      return direction === 'next'
        ? this.active < this.images.length - 1
        : this.active > 0;
    },
    canNavigateThumb(direction) {
      const maxThumbsIndex = Math.ceil(this.images.length / this.thumbs) - 1;
      return direction === 'next'
        ? this.activeThumb < maxThumbsIndex * this.thumbs
        : this.activeThumb > 0;
    },
    navigate(direction) {
      this.active += direction === 'next' ? 1 : -1;
      this.updateThumbsPosition();
    },
    navigateThumb(direction) {
      this.activeThumb += direction === 'next' ? this.thumbs : -this.thumbs;
    },
    updateThumbsPosition() {
      const thumbsPerPage = Math.floor(this.images.length / this.thumbs);
      this.activeThumb =
        Math.floor(this.active / thumbsPerPage) * thumbsPerPage;
    },
    isLastThumb(index) {
      return (
        index === this.thumbs - 1 &&
        this.activeThumb < this.images.length - this.thumbs
      );
    },
    isFirstThumb(index) {
      return index === 0 && this.activeThumb > 0;
    },
  },
};
